<template>
  <div :style="styles.base">
    <template v-if="carouselList.length>0">
      <div :class="getCss('card_swiper')" ref="card_swiper">
        <!-- 轮播项的盒子 -->
        <div :class="getCss('card_swiper_box')" ref="card_swiper_box">
          <!-- 卡片--轮播项 -->
          <div :class="getCss('card')" v-for="(item,index) in carouselList" :key="index" :style="backgroundImage">
            <!-- 卡片左侧 -->
            <div :class="getCss('card_left')">
              <!-- 俱乐部名称 -->
              <h1 :class="getCss('card_left_h1')" :style="titleStyle">{{item.club_name}}</h1>
              <div :class="getCss('card_left_context')">
                <!-- 特色1标题 -->
                <div :class="getCss('card_left_h2')" ref="card_left_h2">
                  <h2 ref="card_left_h2_title" :style="featureOneTitleStyle">{{item.title}}</h2>
                </div>
                <!-- 特色1正文 -->
                <h3 ref="card_left_h3" :class="getCss('card_left_h3')" :style="featureOneContentStyle">{{ item.content }}</h3>
              </div>
              <!-- 特色2标题 -->
              <ul :class="getCss('card_left_ul')" ref="card_left_ul">
                <li ref="card_left_ul_li" :style="featureTwoTitleStyle">{{item.title_two}}</li>
              </ul>
            </div>
            <!-- 卡片右侧 -->
            <div :class="getCss('card_right')">
                <p :style="platStyle">
                  <!-- <span>区区</span>
                  <span>|</span> -->
                  <span>{{ getPlatformName(item.plat) }}</span>
                </p>
                <img :src="item.club_avatar" alt="" :class="getCss('card_right_img')">
                <a 
                  :href="'https://xinyue.qq.com/m/flutter_web/#/unionHome?gid='+item.gid+'&clubId='+item.club_id"
                 :style="joinBtnBackgroundImage"
                 @click="joinClub"
                >
                </a>
            </div>
          </div>
          
        </div>
      </div>
      <!-- 轮播指示器 -->
      <ul :class="getCss('card_swiper_indicator')" ref="card_swiper_indicator">
        <li 
          ref="card_swiper_indicator_li"
          v-for="item in indicatorList" 
          :key="item" 
          :style="indicatorStyle"
          >
        </li>
      </ul>
      <!-- 换一批按钮 -->
      <button :class="getCss('card_change_button')" @click="changeBatch" :style="changeBatchStyle">换一批</button>
    </template>
      <!-- 卡片兜底 -->
      <div v-else :style="revealBackgroundImage" :class="getCss('card_reveal_box')"></div>
    </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin,common } from '@tencent/ceiba-base-components';
export default {
  name: 'CTgclubRecommendClubs',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'tgclub-recommend-clubs-',
      carouselList:[],//轮播的数据
      indicatorList:[0,1,2],//指示器数据
      indicatorCurrentIndex:0,//轮播指示器小圆点
      changeBatchIndex:0,// 换一批次数记录
    };
  },
  computed: {
    backgroundImage(){
      return {backgroundImage: `url(${this.configurationData.backgroundImage || ''})`};
    },
    revealBackgroundImage(){
      return {backgroundImage: `url(${this.configurationData.revealBackgroundImage || ''})`};
    },
    joinBtnBackgroundImage(){
      return {backgroundImage: `url(${this.configurationData.joinBtnBackgroundImage || ''})`};
    },
    titleStyle(){
      return this.styles.titleStyle||{};
    },
    featureOneTitleStyle(){
      return this.styles.featureOneTitleStyle||{};
    },
    featureOneContentStyle(){
      return this.styles.featureOneContentStyle||{};
    },
    featureTwoTitleStyle(){
      return this.styles.featureTwoTitleStyle||{};
    },
    platStyle(){
      return this.styles.platStyle||{};
    },
    changeBatchStyle(){
      return this.styles.changeBatchStyle||{};
    },
    indicatorStyle(){
      return this.styles.indicatorStyle||{};
    },
    defaultColor(){
      return this.configurationData.defaultColor;
    },
    highlightColor(){
      return this.configurationData.highlightColor;
    },
    scrollbarStyle(){
      return this.styles.scrollbarStyle||{backgroundColor:'#979292'};
    }
  },
  mounted() {
    //判断是否登录，登录后在执行下面的操作
    this.$onLogined(async () => {
      await this.initialize();
      await this.cardSwiper();
      await this.cardWordLoop();
    });
    
  },
  methods: {
    async initialize() {
      const {gid=this.currentGid,refresh_type,player_club_square_plat,context=''}=this.configurationData
      const params = { 
        gid:parseInt(gid),
        refresh_type:parseInt(refresh_type),
        player_club_square_plat:parseInt(player_club_square_plat),
        context:context
      };
      var acctype = common.tool.getCookie('acctype'),
          access_token = common.tool.getCookie('access_token'),
          appid = common.tool.getCookie('appid'),
          openid = common.tool.getCookie('openid');
      const response =await this.$axiosInstance({
          method: 'POST',
          url: 'https://bgw.xinyue.qq.com/Commander.UpbotCommanderSrv/GetClubListByGid',
          withCredentials: true,
          // contentType: false, // 不要去设置Content-Type请求头
          headers:{
              'Content-Type': 'application/json',
              'T-ACCESS-TOKEN' : access_token,
              'T-ACCOUNT-TYPE': acctype,
              'T-OPENID': openid,
              'T-APPID': appid,
              'T-MODE': true
          },
          data: params,
        });
        const { ret, msg, data = {} }  = response;
        if (ret !== 0) {
          this.$alert(msg)
          return  
        };
      const list=data.list||[];

      //循环获取一组三个不同的列表数据
      let cardList=[];
      for(var randomIndex=0;randomIndex<3;randomIndex++){
        if(list[randomIndex]){
          cardList.push({
            club_name:list[randomIndex].club.club_name,
            club_avatar:list[randomIndex].club.club_avatar,
            club_id:list[randomIndex].club.club_id,
            gid:list[randomIndex].club.gid,
            plat:list[randomIndex].club.plat,
            title:this.getTypeFiled(list[randomIndex].features[0],list[randomIndex].features[0]?.type,'title'),
            content:this.getTypeFiled(list[randomIndex].features[0],list[randomIndex].features[0]?.type,'content'),
            title_two:this.getTypeFiled(list[randomIndex].features[1],list[randomIndex].features[1]?.type,'title'),
          })
        }
      }
      this.carouselList=cardList.length>0?[cardList[2],...cardList,cardList[0]]:[];
    },
    /**
     * 获取type对应类型字段数据
    */
    getTypeFiled(obj,val,key){
      let field='';
      switch (val){
        case 1:
        field="text";
        break;
        case 2:
        field="image";
        break;
        case 3:
        field="audio";
        break;
        case 4:
        field="video";
        break;
      }
      return obj && field && obj[field]? obj[field][key] : "";
    },
    /**
     * 获取plat对应平台名称
    */
    getPlatformName(val){
      let name='';
      switch (val){
        case 1:
        name="微信区";
        break;
        case 2:
        name="QQ区";
        break;
        case 3:
        name="全区服";
        break;
        case 0:
        field="未知";
        break;
      }
      return name
    },
    /**
     * 卡片轮播事件
    */
    async cardSwiper(){
      const _this=this;
      const { card_swiper ,card_swiper_box,card_swiper_indicator_li} = _this.$refs;
      // 获取focus的宽度
      let w = card_swiper.offsetWidth;
      // 1. 利用定时器
      let index = 0;
      let timer = setInterval(() => {
          index ++;
          let translatex = -index * w;
          moveTransition(card_swiper_box, translatex);
      }, 3000);
      // 2. 监听过渡完成事件transitionend
      card_swiper_box.addEventListener('transitionend', function(){
          if(index >2){
              index = 0;
          } else if(index < 0){
              index = 2;
          }
          let translatex = -index * w;  // 利用新的索引号获取宽度
          moveNoTransition(card_swiper_box, translatex);
          // 3. 小圆点高亮
          [].slice.call(card_swiper_indicator_li).forEach(element => {
            element.style.backgroundColor=_this.defaultColor;
          });
          [].slice.call(card_swiper_indicator_li)[index].style.backgroundColor=_this.highlightColor
          _this.indicatorCurrentIndex=index
        })
      // 4. 手指移动轮播图
      // 触摸元素touchstart 获取手指的初始位置
      var startX = 0, // 定义手指位置
          moveX = 0,  // 定义移动距离
          flag = false;  // 判断是否滑动了
      card_swiper_box.addEventListener('touchstart', function(e){
          startX = e.targetTouches[0].pageX;
          // 停止定时器
          clearInterval(timer);
      })
      // 移动元素touchmove 获取移动距离
      card_swiper_box.addEventListener('touchmove', function(e){
          moveX = e.targetTouches[0].pageX - startX;
          // 移动盒子：盒子原来的距离 + 移动的距离
          let translatex = -index * w + moveX;
          moveNoTransition(card_swiper_box, translatex);
          e.preventDefault();  // 一定注意这个地方，否则会发生moveX基本不改变的现象
          flag = true;
      })
      // 手指离开touchend，根据手指移动的距离来判断是否移动到上一张或者下一张
      card_swiper_box.addEventListener('touchend', function(e){
          // 如果滑动了，才进行如下的判断操作
          if(flag){
              // 判断如果移动距离大于50px那么就移动到下一张或上一张
              if(Math.abs(moveX) > 50){
                  // 如果是右滑就表示滑动到上一张，moveX>0
                  if(moveX > 0){
                      index --;
                  }else{
                      // 如果是左滑就表示滑动到下一张，moveX<0
                      index ++;
                  }                    
              }
              let translatex = -index * w;
              moveTransition(card_swiper_box, translatex);
          }
          // 手指离开后开启定时器
          clearInterval(timer);
          timer = setInterval(() => {
              index ++;
              let translatex = -index * w;
              moveTransition(card_swiper_box, translatex);
          }, 3000);
      })
      // 定义一个过渡滑动效果的函数
      function moveTransition (obj, distance){
          obj.style.transition = 'all .3s';  // 添加过渡效果，0.3s完成图片滚动
          obj.style.transform = 'translateX('+ distance+'px)';
      }
      // 定义一个没有过渡滑动效果的函数
      function moveNoTransition (obj, distance){
          obj.style.transition = 'none';  // 去掉过渡效果，让card_swiper_box快速跳到目标位置
          obj.style.transform = 'translateX('+ distance+'px)';
      }
    },
    /**
     * 文字走马灯效果
    */
    async cardWordLoop(){
      this.$nextTick(()=>{
        const {card_left_h2,card_left_h2_title}=this.$refs;
        let h2=[].slice.call(card_left_h2)[0];
        let title=[].slice.call(card_left_h2_title).splice(1,3);

        title.map(ele=>{
          ele.style.animation='none';
          if(ele.offsetWidth>h2.offsetWidth){
            ele.style.animation='10s wordsLoop linear infinite'
          }
        });
        
        //特色1正文滚动条样式
        var sty=document.createElement('style');
        sty.innerText= `.csu-tgclub-recommend-clubs-card_left h3::-webkit-scrollbar-thumb{background-color: ${this.scrollbarStyle.backgroundColor};}`;
        document.body.appendChild(sty);
      });
    },
    /**
     * 换一批
    */
    async changeBatch(){
     await this.initialize();
     await this.cardWordLoop();
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'another_recommend',
        eventData: {
          status: '1',
        },
      });
    },
    /**
     * 加入俱乐部
    */
    joinClub(){
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'join_club',
        eventData: {
          status: '1',
        },
      });
    }
  }
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
